import React, {useEffect, useState} from "react";
import { Link, useHistory } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Slide } from 'react-slideshow-image';

import Img from "components/Img";
import Button from "components/Button";
import Selectpicker from "components/Input/Selectpicker";
import TextInput from "components/Input/TextInput";
import FeedbackModal from "components/FeedbackModal";

import settings from "configs/settings";

import routes from "configs/routes";
import { formatFloor, formatStatus, formatOrientation, formatMoney } from "functions/formatDynamicData";
import clg from "functions/log";
import { reqAuth } from "functions/req";
import auth from "functions/auth";
import modifyState from "functions/modifyState";

import static_background_image from 'assets/images/csango10-elado-lakasok.webp';
import static_background_image2 from 'assets/images/csango10-13kerulet-elado-lakasok-4.webp';

const ApartmentListItemRow = ({ id, code, status, floor, floor_area, rooms, images, orientation, price, isAuthenticated = false }) => {

    const [isHovered, setIsHovered] = useState(false);
    const [statusState, setStatusState] = useState(status);

    const [globalSubmitBtnLoaderState, setGlobalSubmitBtnLoaderState] = useState(0);

    const [feedback, setFeedback] = useState({
        open : false,
        success : false,
        title : null,
        text : null,
    });

    const history = useHistory();

    const handleAdminChange = ( fieldToSet, value ) => {
        if( isAuthenticated ) {
            let _value = value;

            if( !isNaN( _value ) ) _value = Number( _value );
            
            const objToSend = {
                id : id,
                [fieldToSet] : _value,
            }

            clg("OBJ TO SEND: ", objToSend);

            reqAuth( settings.req.propertyEdit, objToSend).then(function(res){
                clg("MODIFY RES: ", res)
                if( res && res.success ) {

                    switch (fieldToSet) {
                        case "status":
                            setStatusState( value );
                            break;
                    }

                    modifyState( feedback, setFeedback, {"open" : true, "success" : true} );
                } else {
                    modifyState( feedback, setFeedback, {"open" : true, "success" : false} );
                }
            }).catch(err => {
                modifyState( feedback, setFeedback, {"open" : true, "success" : false} );
            })


        }
    }

    return(
        <Link to={ ( !isAuthenticated ? routes.apartment.replace(":id", code) : "") } className={"col-12 apartment-list-item-row " + formatStatus( statusState, "class" ) + ( isAuthenticated ? " admin" : "" )}
        onClick={(e) => {
            if( isAuthenticated ) {
                e.preventDefault();
            }
        }}>
            <motion.div className="row inner"
            custom-attribute="some-value"
            onHoverStart={() => setIsHovered(true)}
            onHoverEnd={() => setIsHovered(false) }
            whileHover={{
                y : -10
            }}
            style={{ backgroundImage : 'url('+ static_background_image2/* images[0] */ +')' }}>
                <div className="col-lg-2 col-12 single-col image-slider-container">

                    <div className="apartment-id">{code}</div>
                    
                    <Slide className="image-slider"
                        arrows={false}
                        canSwipe={false}
                        pauseOnHover={false}
                        duration={750}
                        transitionDuration={1000}
                        autoplay={ isHovered }
                    >
                    {images.map((slideImage, index)=> (
                        <Img src={ slideImage } skeletonprops={{ height : "100%" }} key={"apartment-list-item-row-slide-image-" + index } />
                    ))} 
                    </Slide> 
                </div>

                <div className="col-lg-2 col-4 single-col">
                    <span className={`real-data floor-${floor}`}>{ formatFloor(floor) }</span>
                    <span className="data-title">Emelet</span>
                </div>
                <div className="col-lg-2 col-4 single-col">
                    <span className="real-data">{ floor_area }<span className="postfix">m<sup>2</sup></span></span>
                    <span className="data-title">Bruttó alapterület</span>
                </div>
                <div className="col-lg-2 col-4 single-col">
                <span className="real-data">{ rooms }</span>
                    <span className="data-title">Szobák</span>
                </div>
                <div className="col-lg-2 col-12 single-col btn-container">
                    <Button className="btn-secondary" text="Részletek" onClick={ () => {
                        if( isAuthenticated ) {
                            history.push(
                                routes.apartment.replace(":id", code)
                            )
                        }
                    }}/>
                </div>

                <div className="col-lg-10 badges">
                    <div className="row">
                        {
                            !isAuthenticated && (
                                <>
                                <div className={"apartment-status " + formatStatus( statusState, "class" ) }>{ formatStatus( statusState, "name" ) }</div>
                                <div className={"apartment-price"}><i className="fas fa-tag"></i>{ ( price !== "0" ? formatMoney( price, "M Ft",  ) : "Érdeklődjön" ) }</div>
                                <div className={"apartment-orientation " + formatOrientation( orientation, "value" ) }><i className="far fa-compass"></i>{ formatOrientation( orientation, "label" ) }</div>
                                </>
                            )
                        }
                        {
                            isAuthenticated && (
                                <>
                                <div className={"apartment-status " + formatStatus( statusState, "class" ) }>
                                <Selectpicker
                                    defaultValue={{ value: formatStatus( statusState, "value" ), label: formatStatus( statusState, "name" ) }}
                                    name="status"
                                    options={[
                                        { value: formatStatus( 0, "value" ), label: formatStatus( 0, "name" ) },
                                        { value: formatStatus( 1, "value" ), label: formatStatus( 1, "name" ) },
                                        { value: formatStatus( 2, "value" ), label: formatStatus( 2, "name" ) },
                                        { value: formatStatus( 3, "value" ), label: formatStatus( 3, "name" ) },
                                    ]}
                                    placeholder="Státusz kiválasztása"
                                    className="select-status"
                                    classNamePrefix="select"
                                    onChange={ (selected) => {
                                        handleAdminChange( "status", selected.value )
                                    } }
                                />
                                </div>

                                <div className={"apartment-price"}><i className="fas fa-tag"></i>
                                    <TextInput
                                        type="number"
                                        defaultValue={price}
                                        onBlur={ (e) => handleAdminChange( "gross_price", e.target.value ) }
                                    />
                                    <span className="price-postfix">M Ft</span>
                                </div>
                                <div className={"apartment-orientation " + formatOrientation( orientation, "value" ) }><i className="far fa-compass"></i>{ formatOrientation( orientation, "label" ) }</div>
                                </>
                            )
                        }
                        
                    </div>
                </div>

            </motion.div>

            {
                auth.isAuthenticated() && (
                    <FeedbackModal open={feedback.open} success={feedback.success} title={feedback.title} text={feedback.text} defaultState={ feedback } setDefaultState={ setFeedback }/> 
                )
            }

        </Link>
    )
}

export default ApartmentListItemRow;